import PageTabs from './PageTabs';

const TABS = [
    { href: '/bot/orbs-trader', icon: 'fa-cart-shopping', label: 'ORBS_TRADER_TAB_BUY', exact: true, flag: null },
    { href: '/bot/orbs-trader/sell', icon: 'fa-coins', label: 'ORBS_TRADER_TAB_SELL', exact: false, flag: null },
] as const;

export default function OrbsTraderNav() {
    return <PageTabs tabs={TABS} />;
}
